import UISection from 'UIComponents/section/UISection';
import WebhookEnrollExistingStep from 'automation-ui-enrollment/components/eventEnrollment/steps/WebhookEnrollExistingStep';
import { jsx as _jsx } from "react/jsx-runtime";
const WebhookEnrollmentStep = ({
  allowObjectTypeSelection,
  objectTypeId,
  setObjectTypeId,
  propertyMappings,
  setObjectAssociation,
  setDisableSubmit,
  propertyValueDefinitions,
  setPropertyValueDefinitions
}) => {
  return /*#__PURE__*/_jsx(UISection, {
    children: /*#__PURE__*/_jsx(WebhookEnrollExistingStep, {
      allowObjectTypeSelection: allowObjectTypeSelection,
      objectTypeId: objectTypeId,
      setObjectTypeId: setObjectTypeId,
      propertyMappings: propertyMappings,
      setDisableSubmit: setDisableSubmit,
      setObjectAssociation: setObjectAssociation,
      setPropertyValueDefinitions: setPropertyValueDefinitions,
      propertyValueDefinitions: propertyValueDefinitions
    })
  });
};
export default WebhookEnrollmentStep;